// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".categories .v-slide-group__next,.categories .v-slide-group__prev{top:0}.categories .v-slide-group__prev{right:-10px}.categories .v-slide-group__next{left:-10px}.v-application--is-ltr .categories .v-slide-group__prev{left:-10px;right:unset}.v-application--is-ltr .categories .v-slide-group__next{left:unset;right:-10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
